import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const TimelineWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.75rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
`

export const TimelineRow = styled.div`
  display: grid;
  grid-template-columns: 1rem 1fr auto;
  align-items: baseline;
  gap: 0.5rem;
  padding: 0.25rem 0;
`

export const TimelineDot = styled.span<{ $state: 'done' | 'active' | 'pending' }>`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 999px;
  justify-self: center;
  align-self: center;
  background: ${({ $state }) =>
    $state === 'done'
      ? tokens.status.success.fg
      : $state === 'active'
        ? tokens.status.warning.fg
        : tokens.border.strong};
`

export const TimelineLabel = styled.span<{ $dim?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${({ $dim }) => ($dim ? tokens.text.muted : tokens.text.primary)};
`

export const TimelineTime = styled.span<{ $dim?: boolean }>`
  font-size: ${tokens.font.label};
  color: ${({ $dim }) => ($dim ? tokens.text.muted : tokens.text.secondary)};
  font-variant-numeric: tabular-nums;
`

export const TimelineNote = styled.p<{ $warning?: boolean }>`
  margin-top: 0.25rem;
  font-size: ${tokens.font.label};
  color: ${({ $warning }) => ($warning ? tokens.status.warning.fg : tokens.text.muted)};
`

export const ReceiptActionWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px dashed ${tokens.border.hairline};
`
